import { render, staticRenderFns } from "./LabelSimple.vue?vue&type=template&id=38bf5dc0&scoped=true"
import script from "./LabelSimple.vue?vue&type=script&lang=js"
export * from "./LabelSimple.vue?vue&type=script&lang=js"
import style0 from "./LabelSimple.vue?vue&type=style&index=0&id=38bf5dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf5dc0",
  null
  
)

export default component.exports